

import React, { useState, useRef } from "react";
import { minus, plus } from "../../assets/imagesPath";
import { Link } from "react-router-dom";

const Faqs = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [openSection, setOpenSection] = useState(null);

  const categoryRefs = useRef([]);

  const toggleSection = (id) => {
    setOpenSection(openSection === id ? null : id);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const handleScrollToCategory = (label) => {
    const element = categoryRefs.current[label];
    if (element) {
      const yOffset = -180;
      const yPosition = element.getBoundingClientRect().top + window.scrollY + yOffset;

      window.scrollTo({
        top: yPosition,
        behavior: "smooth",
      });
    }
  };

  const faqData = [
    {
      "label": "Getting Started",
      "faqs": [
        {
          "id": 24,
          "title": "How do I schedule a consultation?",
          "content": "Submit an inquiry through our Contact page, and we'll arrange a consultation tailored to your needs."
        },
        {
          "id": 25,
          "title": "What do I need to start working with SBAAA LLC?",
          "content": "You'll need basic business and financial information. If additional services are needed, we'll guide you or refer you to a trusted affiliate listed on our Network Affiliates page."
        },
        {
          "id": 26,
          "title": "Can I switch to SBAAA LLC from another provider?",
          "content": "Yes, we'll handle the transition process. For any needs outside our expertise, we'll provide guidance or refer you to a trusted affiliate."
        }
      ]
    },
    {
      "label": "General Information",
      "faqs": [
        {
          "id": 1,
          "title": "What services does SBAAA LLC offer?",
          "content": "SBAAA LLC provides core services like bookkeeping, financial planning, business advisory, tax planning, and LLC/S-Corp formation. For services outside our expertise, we can guide you on the next steps or refer you to one of our trusted network affiliates. Refer to our Services page for more information."
        },
        {
          "id": 2,
          "title": "How can SBAAA LLC help my small business?",
          "content": "We streamline your finances, save you time, and help you make informed decisions. If a need arises outside our expertise, we will offer guidance or recommend a trusted affiliate. Learn more on our Services page."
        },
        {
          "id": 3,
          "title": "Do you work with businesses in specific industries?",
          "content": "Yes, we specialize in serving small businesses and tradespeople, such as electricians, plumbers, and remodelers. For highly specialized needs, we'll connect you with affiliates listed on our Network Affiliates page."
        },
        {
          "id": 4,
          "title": "What size businesses does SBAAA LLC typically serve?",
          "content": "We primarily work with small businesses with fewer than five employees."
        }
      ]
    },
    {
      "label": "Bookkeeping and Financial Management",
      "faqs": [
        {
          "id": 5,
          "title": "What is included in your bookkeeping services?",
          "content": "Our bookkeeping services include transaction tracking, financial reporting, and cash flow management. For additional or specialized services, we may recommend trusted affiliates or guide you on how to proceed. Visit our Services page for a full breakdown."
        },
        {
          "id": 6,
          "title": "How do I start using your bookkeeping services?",
          "content": "To start with our bookkeeping services, visit our Services page and select the option that best fits your business needs."
        },
        {
          "id": 7,
          "title": "Can SBAAA LLC help me clean up past financial records?",
          "content": "Yes, we specialize in cleaning up past financial records. Our team will review your existing data, identify any discrepancies, and ensure your records are accurate and up to date. This service is tailored to help you start fresh with clear financial insights, so you can confidently manage your business moving forward."
        },
        {
          "id": 8,
          "title": "How often will I receive financial reports?",
          "content": "We deliver reports monthly, which are included in our standard services. Reporting outside the standard scope may be available for an additional fee."
        }
      ]
    },
    {
      "label": "Business Formation and Advisory",
      "faqs": [
        {
          "id": 9,
          "title": "Can SBAAA LLC assist with LLC or S-Corp formation?",
          "content": "Yes, we simplify the formation process. For legal or compliance matters beyond our expertise, we can guide you or refer you to an affiliate. See our Services page for details."
        },
        {
          "id": 10,
          "title": "What are the benefits of forming an LLC or S-Corp?",
          "content": "LLCs offer operational flexibility, while S-Corps may provide tax savings. To better understand the differences and which structure may be right for you, refer to the resources in our Knowledge Hub."
        },
        {
          "id": 11,
          "title": "Does SBAAA LLC provide business growth advice?",
          "content": "Yes, we offer advisory services for financial planning and business growth strategies. For advanced business strategy consulting, we can recommend a trusted affiliate. Learn more on our Services page."
        },
        {
          "id": 12,
          "title": "How does SBAAA LLC ensure compliance with regulations?",
          "content": "We stay informed about federal and state regulations to ensure compliance. For complex legal or regulatory issues, we'll recommend affiliates who specialize in those areas."
        }
      ]
    },
    {
      "label": "Tax Planning and Compliance",
      "faqs": [
        {
          "id": 13,
          "title": "Does SBAAA LLC handle tax filing?",
          "content": "We partner with licensed CPAs in our network to provide tax filing services. See our Services page for more details."
        },
        {
          "id": 14,
          "title": "Can you help minimize my tax liability?",
          "content": "Yes, we implement proactive strategies to identify deductions and reduce tax liability."
        },
        {
          "id": 15,
          "title": "What should I prepare for tax planning services?",
          "content": "You'll need your financial records, prior tax filings, and other relevant documents. If additional preparation is required, we'll advise you or recommend an affiliate."
        },
        {
          "id": 16,
          "title": "How does SBAAA LLC ensure year-round tax compliance?",
          "content": "We provide ongoing planning and guidance. For advanced compliance needs, we will guide you to one of our trusted affiliates."
        }
      ]
    },
    {
      "label": "Pricing and Payment Information",
      "faqs": [
        {
          "id": 17,
          "title": "What are the costs of your services?",
          "content": "Pricing is customized based on your needs. Refer to our Services page for details."
        },
        {
          "id": 18,
          "title": "Do you offer subscription-based pricing?",
          "content": "Yes, most of our services are available on a monthly subscription basis. We also offer one-time services, such as business formation packages or financial consultations, depending on your needs."
        },
        {
          "id": 19,
          "title": "What payment methods are accepted?",
          "content": "We accept major credit cards and secure online payments."
        },
        {
          "id": 20,
          "title": "Are there additional fees for your services?",
          "content": "Certain services may involve additional fees. For example, reporting outside the standard scope or other specialized requests may incur additional charges. We will inform you upfront. Refer to our Services page for more details."
        }
      ]
    },
    {
      "label": "Security and Confidentiality",
      "faqs": [
        {
          "id": 21,
          "title": "How does SBAAA LLC protect my data?",
          "content": "We use encrypted systems and secure servers to safeguard your financial information. More details are on our Privacy Policy page."
        },
        {
          "id": 22,
          "title": "Is my data shared with third parties?",
          "content": "Your data is only shared with trusted network affiliates when necessary and with your consent."
        },
        {
          "id": 23,
          "title": "What systems are in place to maintain data security?",
          "content": "We use industry-standard protocols and secure software to ensure privacy and compliance."
        }
      ]
    },
    {
      "label": "Transaction Limits and Scaling",
      "faqs": [
        {
          "id": 27,
          "title": "How many transactions are included in the Basic and Standard Packages?",
          "content": "The Basic Package includes up to 50 transactions per month, and the Standard Package includes up to 100 transactions per month."
        },
        {
          "id": 28,
          "title": "What happens if I exceed my transaction limit?",
          "content": "You will automatically be upgraded to include additional increments of 25 transactions for $50/month."
        },
        {
          "id": 29,
          "title": "What is considered a transaction?",
          "content": "Transactions include revenue (client payments), materials purchases, payroll, and other business-related expenses."
        },
        {
          "id": 30,
          "title": "How do I track my transaction count?",
          "content": "You don't need to! Our systems automatically monitor your transaction count and notify you if you approach your limit."
        },
        {
          "id": 31,
          "title": "What if I outgrow the Standard Package?",
          "content": "No problem! We can scale your plan with additional increments or create a custom package tailored to your needs."
        }
      ]
    }
  ];

  const filteredData = faqData.map((category) => ({
    ...category,
    faqs: category.faqs.filter(
      (faq) =>
        faq.title.toLowerCase().includes(searchTerm) ||
        faq.content.toLowerCase().includes(searchTerm)
    ),
  }));

  return (
    <div className="w-full">

      <div className="mt-12 flex items-center justify-center">
          <input
            type="text"
            placeholder="Search FAQs"
            value={searchTerm}
            onChange={handleSearch}
            className="w-2/4 p-4 rounded-full border border-sky-100 h-[6rem] pl-12 text-2xl focus:outline-none shadow-custom-light2"
          />
        </div>

      <div className="grid grid-cols-12 smallScreens:grid-cols-1 my-28 px-[8%] smallScreens:px-[5%] gap-16">
        <div className="col-span-3 smallScreens:col-span-12">
          <div className="shadow-custom-light2 rounded-xl">
            {faqData.map((category, index) => (
              <button
                key={category.label}
                onClick={() => handleScrollToCategory(index)}
                className="flex items-center justify-between text-left text-2xl font-semibold focus:outline-none hover:bg-slate-50 p-7 w-full border-b border-sky-100"
              >
                {category.label} <span>→</span>
              </button>
            ))}
          </div>
        </div>

        <div className="col-span-9 smallScreens:col-span-12">
          {filteredData.map(
            (category, index) =>
              category.faqs.length > 0 && (
                <div
                  key={category.label}
                  ref={(el) => (categoryRefs.current[index] = el)}
                  className="mb-12"
                >
                  <h2 className="text-4xl font-bold smallScreens:text-2xl mb-10 text-[#173363]">{category.label}</h2>
                  {category.faqs.map((item) => (
                    <div
                      key={item.id}
                      className="border-0 rounded-lg mb-8 shadow-custom-light2 bg-white px-10"
                    >
                      <button
                        className="flex items-center w-full p-4 transition duration-300 h-[8rem]"
                        onClick={() => toggleSection(item.id)}
                      >
                        <span
                          className="text-3xl font-bold mr-10 transition-transform duration-300"
                        >
                          {openSection === item.id ? (
                            <img src={minus} className="w-[15px] h-[3px] mr-2" alt="Minus Icon" />
                          ) : (
                            <img src={plus} className="h-[15px] w-[15px] mr-2" alt="Plus Icon" />
                          )}
                        </span>
                        <span className="font-bold text-[1.6rem] mt-1 text-left">{item.title}</span>
                      </button>

                      <div
                        className={`overflow-hidden transition-max-h duration-500 ease-in-out ${openSection === item.id ? "max-h-96" : "max-h-0"
                          }`}
                      >
                        <div className="bg-white font-normal text-[1.4rem] text-[#363049] px-[6rem] pb-[3rem] leading-relaxed">
                          {item.content}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )
          )}
        </div>
      </div>
    </div>
  );
};

export default Faqs;